import React from 'react'
import ReactDOM from 'react-dom'

function MarkerWrapper({ google, }) {
  function Marker({ lat, lng, map, marker, customMarker, markerSelected, }) {
    this.lat = lat
    this.lng = lng
    this.marker = marker
    this.customMarker = customMarker
    this.markerSelected = markerSelected
    this.latlng = new google.maps.LatLng(lat, lng)
    this.setMap(map)
  }

  Marker.prototype = new google.maps.OverlayView()

  Marker.prototype.draw = function draw() {
    let div = this.div
    if (!div) {
      this.div = document.createElement('div')
      div = this.div
      div.style.position = 'absolute'
      const panes = this.getPanes()
      panes.overlayImage.appendChild(div)
      const CustomMarker = this.customMarker
      ReactDOM.render(
        <CustomMarker marker={this.marker} markerSelected={this.markerSelected} />,
        div
      )
    }
    const point = this.getProjection().fromLatLngToDivPixel(this.latlng)
    if (point) {
      div.style.left = `${point.x}px`
      div.style.top = `${point.y}px`
    }
  }

  Marker.prototype.remove = function remove() {
    if (this.div) {
      this.div.parentNode.removeChild(this.div)
      this.div = null
    }
  }

  Marker.prototype.getPosition = function getPosition() {
    return this.latlng
  }

  return Marker
}

export default MarkerWrapper



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/Map/MarkerWrapper.js